/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React from 'react';
import { ViewValues } from '../survey-overview-sidebar/viewOptions';
import { SurveyModelMinData } from '../../model/surveyData';
import SurveyQuestionList from '../survey-question-list/survey-question-list';
import { Breadcrumb, ScopeQuestionOptionalValue } from '../../types/surveyScope';
import { sortItemsByTypeCode } from '../../utils/sort';
import { convertToFilters } from '../survey/utils/useScopeFilters';
import { standards } from '@g17eco/core';

interface ScopeQuestionListProps {
  surveyData: SurveyModelMinData,
  questions: ScopeQuestionOptionalValue[],
  view: ViewValues;
  breadcrumbs: Breadcrumb[];
}

export const shouldShowScopeQuestions = (cardGroup: ViewValues) => [
  ViewValues.StandardsQuestionList,
].includes(cardGroup);

const viewWithStandards = [ViewValues.Standards, ViewValues.QuestionPacks];

export const ScopeQuestionList = (props: ScopeQuestionListProps) => {
  const { surveyData, questions, view, breadcrumbs } = props;

  const filters = convertToFilters(view, breadcrumbs);
  const filter = filters.find(f => viewWithStandards.includes(f.type as ViewValues));
  // Ensure filter value is valid altCode, excludes frameworks from QuestionPack
  const alternativeCode = filter?.value && standards[filter.value] ? filter.value : '';

  return <SurveyQuestionList
    surveyGroups={[{
      groupName: '',
      list: sortItemsByTypeCode(questions, alternativeCode)
    }]}
    alternativeCode={alternativeCode}
    surveyId={surveyData._id}
    initiativeId={surveyData.initiativeId}
  />
}
